import React, { useEffect, useState } from "react";
import { Gamepad2, Zap, Trophy, Sparkles } from "lucide-react";

export const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 200);

    return () => {
      document.body.style.overflow = "auto";
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-[#0a0a0f] via-[#141420] to-[#0a0a0f] overflow-hidden animate-fade-in">
      {/* Animated Background Particles - CSS Only */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-cyan-400/30 rounded-full animate-float-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`,
            }}
          />
        ))}
      </div>

      {/* Glowing Orbs - CSS Only */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl animate-pulse-glow" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-purple-500/20 rounded-full blur-3xl animate-pulse-glow-delayed" />

      {/* Main Content */}
      <div className="relative flex flex-col items-center space-y-8 z-10">
        {/* Premium Circular Loader */}
        <div className="relative w-40 h-40 animate-scale-in">
          {/* Outer Rotating Ring */}
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-cyan-400 border-r-purple-500 animate-spin-slow" />
          
          {/* Middle Counter-Rotating Ring */}
          <div className="absolute inset-3 rounded-full border-4 border-transparent border-b-blue-400 border-l-pink-500 animate-spin-reverse" />
          
          {/* Inner Pulsing Ring */}
          <div className="absolute inset-6 rounded-full border-2 border-cyan-400/30 animate-pulse-ring" />
          
          {/* Center Game Icon */}
          <div className="absolute inset-8 rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-sm border border-white/10 flex items-center justify-center animate-glow">
            <div className="relative">
              <Gamepad2 className="w-10 h-10 text-cyan-400 animate-bounce-subtle" />
              
              {/* Orbiting Sparkles */}
              <div className="absolute -top-4 -right-4 animate-orbit">
                <Sparkles className="w-4 h-4 text-yellow-400" />
              </div>
              <div className="absolute -bottom-4 -left-4 animate-orbit-reverse">
                <Zap className="w-4 h-4 text-purple-400" />
              </div>
            </div>
          </div>

          {/* Progress Ring SVG */}
          <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="46"
              fill="none"
              stroke="rgba(255,255,255,0.05)"
              strokeWidth="2"
            />
            <circle
              cx="50"
              cy="50"
              r="46"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeDasharray={`${Math.min(progress, 100) * 2.89} 289`}
              className="transition-all duration-300 ease-out"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#22d3ee" />
                <stop offset="50%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#a855f7" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        
        {/* Progress Percentage */}
        <div className="text-center animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <p className="text-cyan-400 font-mono text-2xl font-bold">
            {Math.min(Math.round(progress), 100)}%
          </p>
        </div>

        
      </div>

      {/* Bottom Decorative Line */}
      {/* <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-slide-in-bottom" /> */}
    </div>
  );
};
